module.exports = __webpack_public_path__ + "img/mobile-59.e6f5d0ad.png";